import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=2f4bccc2"
import script from "./course-detail.vue?vue&type=script&lang=js"
export * from "./course-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4bccc2')) {
      api.createRecord('2f4bccc2', component.options)
    } else {
      api.reload('2f4bccc2', component.options)
    }
    module.hot.accept("./course-detail.vue?vue&type=template&id=2f4bccc2", function () {
      api.rerender('2f4bccc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/course-detail.vue"
export default component.exports